<template>
    <div class="upload-img">
        <div class="btn-upload text-center" role="button" @click="upload()"
            v-if="files.length == 0 && fileUploaded.length == 0">
            <p class="mb-0"><i class="icon ion-md-cloud-upload"></i></p>
            <p class="mb-0">Thêm ảnh</p>
        </div>
        <div :class="{
                'list-img': true,
                'vg-scrollbar': $detect == 'web'
            }" v-else>
            <div class="d-flex flex-nowrap list-item-img mb-2">
                <div class="btn-img text-center mx-2" role="button" @click="upload()">
                    <p class="mb-0"><i class="icon ion-md-cloud-upload"></i></p>
                    <p class="mb-0 fs-14px">Thêm ảnh</p>
                </div>
                <div :class="{
                        'img mx-2 position-relative': true,
                        'img-mobile': $detect == 'mobile'
                    }" v-for="item in files" :key="item.lastModified" v-show="item.show">
                    <img class="w-100 h-100" :src="item.url"/>
                    <div class="loading-img position-absolute">
                        <div class="dashed-loading"></div>
                    </div>
                </div>
                <div :class="{
                        'img mx-2 position-relative img-hover': true,
                        'img-mobile': $detect == 'mobile'
                    }" v-for="(item, index) in fileUploaded" :key="index">
                    <img class="w-100 h-100" :src="item.url" @click="picture1 = item.filename"/>
                    <div class="position-absolute img-primary w-100 bg-success text-white fs-12px text-center"
                        v-if="item.filename === picture1">
                        <i class="icon ion-md-checkmark mr-2"></i>Ảnh chính
                    </div>
                    <div class="delete-img position-absolute" @click="destroyImage(item, index)"><i class="icon ion-md-close text-white"></i></div>
                </div>
            </div>
        </div>
        <input type="file" v-show="false" multiple class="input-upload" @change="changeImage"/>
        <div class="d-flex justify-content-between">
            <div class="fs-12px text-note-img">* Vui lòng click vào ảnh làm ảnh chính tin rao</div>
            <div class="fs-12px">Đã chọn {{fileUploaded.length}} ảnh</div>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error || errorPicture">{{error || errorPicture}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error', 'pictureMain', 'errorPicture', 'exclusive'],
    data() {
        return {
            fileUploaded: [],
            files: [],
            picture1: '',
            id: this.$route.params.id,
        }
    },
    watch: {
        data(val){
            this.fileUploaded = val;
        },
        fileUploaded(val){
            this.$emit('update:data', val);
        },
        picture1(val){
            this.$emit('update:pictureMain', val);
        },
        pictureMain(val){
            this.picture1 = val;
        }
    },
    created() {

    },
    methods: {
        upload(){
            let input = this.$el.querySelector('.input-upload');
            input.click();
        },
        async changeImage(e){
            this.$emit('update:error', '');
            this.$emit('update:errorPicture', '');
            let files = e.target.files;
            for(let item of files){
                item.url = URL.createObjectURL(item);
                item.show = true;
                this.files.unshift(item);
            }
            await this.uploadCdn();
        },
        async uploadCdn(){
            let form;
            for(let item of this.files.reverse()){
                if(item.type == 'image/jpeg' || item.type == 'image/png' || item.type == 'image/jpg'){
                    form = new FormData();
                    form.append('files', item);
                    await apiPost(`https://cdnvg.scandict.com/upload.php`, form).then(async res => {
                        let data = res[0];
                        if(data.success == 1){
                            this.fileUploaded.unshift(data);
                            this.hiddenFile(item.lastModified);
                        }else{
                            this.$message({
                                message: `Upload ảnh ${item.name} bị lỗi`,
                                type: 'error',
                                center: true,
                            });
                            this.hiddenFile(item.lastModified);
                        }
                    }).catch(err => {
                        this.$message({
                            type: 'error',
                            message: 'Lỗi hệ thống',
                            center: true,
                        });
                        this.hiddenFile(item.lastModified);
                    });
                }
            }
            this.files = [];
        },
        hiddenFile(lastModified){
            this.files.map((item, index) => {
                if(item.lastModified === lastModified){
                    this.files[index].show = false;
                }
            })
        },
        destroyImage(item, index){
            if(this.files.length > 0){
                this.$message({
                    message: 'Đang upload ảnh vui lòng chờ',
                    type: 'warning',
                    center: true,
                });
                return;
            }
            if(this.picture1 == item.filename) this.picture1 = '';

            if(item.gallery_id){
                apiPost(`v2/profile/product/picture/${this.id}`,  {
                        gallery_id: item.gallery_id,
                        exclusive : this.exclusive,
                    }).then(res => {
                    console.log('Xóa ảnh thành công!')
                }).catch(err => {
                    console.warning('Lỗi hê thống!')
                });
            }
            this.fileUploaded.splice(index, 1);
        }
    }
}
</script>
<style lang="scss">
.rv-create {
    .body {
        .upload-img {
            .btn-upload {
                border: 2px dashed rgba(0, 0, 0, 0.2);
                border-radius: 4px;
                color: #666;
                height: 120px;
                padding: 22px 0;
                i {
                    font-size: 30px !important;
                }
            }
            .list-img {
                overflow-x: auto;
                &::-webkit-scrollbar {
                    height: 7px;
                }
                .btn-img {
                    border: 2px dashed rgba(0, 0, 0, 0.2);
                    border-radius: 4px;
                    color: #666;
                    width: 120px;
                    height: 120px;
                    padding: 26px 0;
                    flex: 0 0 auto;
                    i {
                        font-size: 25px !important;
                    }
                }
                .img {
                    width: 15%;
                    height: 120px;
                    cursor: pointer;
                    flex: 0 0 auto;
                    img {
                        object-fit: cover;
                        border-radius: 4px;
                        box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
                    }
                    .img-primary {
                        bottom: 0;
                        padding: 2px 0;
                        border-radius: 0 0 5px 4px;
                    }
                }
                .img-mobile {
                    width: 50% !important;
                    .delete-img {
                        display: block !important;
                    }
                }
            }
        }
        .img-hover:hover {
            .delete-img {
                display: block !important;
            }
        }
        .delete-img {
            top: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.6);
            display: none;
            cursor: pointer;
            z-index: 3000;
            i {
                padding: 10px 8px;
            }
        }
        .loading-img {
            width: 100%;
            height: 100%;
            top: 0;
            background: rgba(255, 255, 255, 0.8);
        }
        .text-note-img {
            color: #666;
            font-style: italic;
        }
        .dashed-loading {
            position: absolute;
            top: 55%;
            height: 50%;
            left: 35%;
            transform: translate(-50%, -50%);
            &:after, &:before {
                content: "";
                position: absolute;
                border-radius: 50%;
                width: 50px;
                height: 50px;
            }
            &:before {
                z-index: 5;
                border: 3px dashed #007bff;
                border-left: 3px solid transparent;
                border-bottom: 3px solid transparent;
                -webkit-animation: dashed 1s linear infinite;
                animation: dashed 1s linear infinite;
            }
            &:after {
                z-index: 10;
                border: 3px solid #007bff;
                border-left: 3px solid transparent;
                border-bottom: 3px solid transparent;
                -webkit-animation: dashed 1s ease infinite;
                animation: dashed 1s ease infinite;
            }
        }
        @keyframes dashed {
            to {
                transform: rotate(360deg);
            }
        }
    }
}
</style>
